import Experiments from '@alltrails/shared/types/Experiments';
import { useEffect, useState } from 'react';

export const homepageBranchLink = 'https://alltrails.io/rgGVELw1wCb';

const aotyFlagKey = 'web-growth-rm-mweb-appinstall-visual';

const useDeeplink = (pageType?: 'area' | 'trail', pageId?: number, aotyExperiment?: Experiments[typeof aotyFlagKey]) => {
  // Use app homepage deeplink for initial state.
  const [deeplink, setDeeplink] = useState(homepageBranchLink);

  useEffect(() => {
    const branchLinkBase = 'https://alltrails-alternate.app.link';

    let appPath = `alltrails://screen/explore`;
    let aotyExperimentParams = '';

    if (pageType && pageId) {
      appPath = `alltrails://${pageType}/${pageId}`;
    }

    if (aotyExperiment) {
      aotyExperimentParams = `&experiment=${aotyFlagKey}&variant=${aotyExperiment.value}`;
    }

    // Branch long-link isn't built using URLParams to prevent serializing deeplink paths.
    // eslint-disable-next-line max-len
    const branchDeeplink = `${branchLinkBase}?type=install_prompt&$ios_deeplink_path=${appPath}&$android_deeplink_path=${appPath}${aotyExperimentParams}`;

    setDeeplink(branchDeeplink);
  }, [aotyExperiment, pageId, pageType]);

  return deeplink;
};

export default useDeeplink;
